export function authHeader() {
  // return authorization header with jwt token
  const accessToken = sessionStorage.getItem("accessToken");
  if (accessToken && accessToken != "") {
    //let accssTokenString = JSON.parse(JSON.stringify(accessToken)); //.replace(/"/g, "");
    return { Authorization: "Bearer " + accessToken };
  } else {
    return {};
  }
}
